import {
    VehicleSpecsFeaturesPacks,
    VehicleSpecsFeaturesPacksKeys,
} from "resolvers/data/pdp/pdpVehicleSpecsResolver";

import { OrderedSpec } from "../components/VehicleDetails/components/CarSpecs";

const KeyTypes: VehicleSpecsFeaturesPacksKeys[] = [
    "vehicleSpecsSummary",
    "dimensions",
    "performance",
    "warranty",
    "runningcosts",
    "generalspecs",
    "mot",
    "servicehistory",
];

const specDataHelper = <T>({
    maxSummarySpecs,
    specs,
    specsOrder,
    callbackFn,
    specsKey,
}: {
    specs: VehicleSpecsFeaturesPacks;
    maxSummarySpecs: number;
    specsOrder: OrderedSpec[];
    specsKey?: VehicleSpecsFeaturesPacksKeys;
    callbackFn(spec: OrderedSpec, value: string): T;
}): { validSpecsCount: number; orderedSpecs: T[] } => {
    let validSpecsCount = 0;

    let orderedSpecs: T[] = [];

    if (!specsKey) {
        let listOfSpecs: { [key: string]: any } = {};

        Object.entries(specs).forEach(([key, value]) => {
            if (KeyTypes.includes(key as VehicleSpecsFeaturesPacksKeys) && Array.isArray(value)) {
                value.forEach((v) => {
                    if (typeof v === "object")
                        listOfSpecs = {
                            ...listOfSpecs,
                            ...v,
                        };
                });
            }
        });

        orderedSpecs = specsOrder
            .reduce((acc, spec) => {
                if (!Object.keys(listOfSpecs).includes(spec.key)) return acc;
                validSpecsCount = validSpecsCount + 1;
                return [...acc, callbackFn(spec, listOfSpecs[spec.key])];
            }, [] as T[])
            .slice(0, maxSummarySpecs);
    } else {
        orderedSpecs = specsOrder
            ?.reduce((acc, spec) => {
                const value =
                    spec.key &&
                    specs[specsKey]?.find((item) => {
                        const [key] = Object.entries(item)[0];
                        return key === spec.key;
                    });

                if (!value) return acc;
                validSpecsCount = validSpecsCount + 1;
                return [...acc, callbackFn(spec, value[spec.key])];
            }, [] as T[])
            .slice(0, maxSummarySpecs);

        // If no ordered specs find a match, then use all unordered values
        if (!orderedSpecs?.length) {
            orderedSpecs = specs?.[specsKey]
                .map((item) => {
                    const [key, value] = Object.entries(item)[0];
                    validSpecsCount = validSpecsCount + 1;
                    return callbackFn(
                        {
                            key,
                            label: key,
                            postfix: specsKey == "servicehistory" ? " miles" : "",
                        },
                        value
                    );
                })
                .slice(0, maxSummarySpecs);
        }
    }

    return { validSpecsCount, orderedSpecs };
};

export default specDataHelper;
